import { Link, useOutletContext } from "react-router-dom";
import "./Home.css";
import AuthForm from "../components/AuthForm";
import { AuthContext } from "../components/Layout";
import NotificationManager from "../components/NotificationManager";

const VAPID_PUBLIC_KEY = "BFDiy1DbOVk0Bn4R2J9hjGxD5TkXLxETORSC0pUxmzRGNYs1HgROTMj5dzzrKWKJsGOYvq6nvAb-mMGZ_zxxLws";

function Home() {
  const { user, onLogin } = useOutletContext<AuthContext>();

  return (
    <div className="home-container">
      <h1 className="welcome-header">Welcome to FifteenShared</h1>
      <p className="intro">
        FifteenShared is a collaborative crossword solving platform. You can
        solve crosswords on your own or with friends in real-time.
      </p>
      {!user ? (
        <AuthForm onLoginSuccess={onLogin} />
      ) : ( <></> )}
        <div className="options-grid">
          <Link to="/solo" className="option-card">
            <h2>Create Session</h2>
            <p>Practice on your own or with friends with our collection of crosswords</p>
            <span className="arrow">→</span>
          </Link>

          <Link to="/join-create-session" className="option-card">
            <h2>Join a Group Session</h2>
            <p>Join a collaborative solving session with friends</p>
            <span className="arrow">→</span>
          </Link>

        </div>
      {user && (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
          <NotificationManager vapidPublicKey={VAPID_PUBLIC_KEY} />
        </div>
      )}

    </div>
  );
}

export default Home;
